import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
import { useRouter } from 'next/router';

const R: React.FC = () => {
    const { useLang, Link } = useGlobal();
    const { t } = useLang('R');
    const { locale = 'us', pathname } = useRouter();
    return (
        <div
            id="power-preparedness-R "
            className={`power-preparedness-R ${css['power-preparedness-R']} GtmModuleData-section`}
            data-section-id={'powerPreparedness-R'}
            data-section-title={t('secR_title1')}
        >
            <div className="footer-disclaimer page-layout">
                <div className="">
                    <p>{t('secR_title1')}</p>
                    <p>{t('secR_title2')}</p>
                    <p>{t('secR_title3')}</p>
                    {locale === 'us' && (
                        // <p>
                        //     {t.rich('secR_title', {
                        //         strong: (text: string) => {
                        //             return <b className="strong-text">{text}</b>;
                        //         },
                        //     })}
                        // </p>
                        <>
                            <p>{t('secR_title4')}</p>
                            <p>{t('secR_title5')}</p>
                            <p>{t('secR_title6')}</p>
                            <p>{t('secR_title7')}</p>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default R;
